import type { BadgeStatus } from '@indipia/ui-core';

/**
 * 현장 상태 → Badge status (D-09 §15.5).
 *
 * 인디포토 전 화면의 단일 기준이다. 같은 현장이 목록·분류·SitePanel 에서
 * 다른 색으로 보이지 않도록 여기 한 곳에서만 정한다.
 *
 * 등록 ACTIVE = info(파랑) / 진행중 PROGRESS = success(초록)
 * 완료 DONE = done(회색) / 실패 FAIL = danger(빨강)
 */
export function siteStatusBadge(s: string | null | undefined): BadgeStatus {
  switch (s?.toUpperCase()) {
    case 'ACTIVE':   return 'info';
    case 'PROGRESS': return 'success';
    case 'DONE':     return 'done';
    case 'FAIL':     return 'danger';
    default:         return 'mute';
  }
}

/** 현장 상태 코드 → 표시 이름. 서버 이름(siteStatusName)이 없는 화면에서만 쓴다(SitePanel 표기와 같다). */
export function siteStatusLabel(s: string | null | undefined): string {
  switch (s?.toUpperCase()) {
    case 'ACTIVE':   return '등록';
    case 'PROGRESS': return '진행중';
    case 'DONE':     return '거래완료';
    case 'FAIL':     return '실패';
    default:         return s ?? '';
  }
}
